<template>
  <div>
    <div>
      <div class="d-flex">
        <div class="py-2" :class="aboutClass">
          <!-- :class="{
            'mb-2 mt-1  text-center': ocultar,
            ' text-center': !ocultar,
          }" -->
          <div :class="{
            'mb-2 mt-1 d-flex justify-content-center': ocultar,
            'd-flex justify-content-center': !ocultar,
          }">

            <div :class="{ 'd-flex flex-column align-items-start': aboutClass === 'wider-about' }">

              <img class="text-white" @click="ocultarNavbar" src="../../assets/responsive.svg" alt=""
                :class="{ 'd-block mx-auto': aboutClass === 'wider-about' }"   style="filter: invert(1) brightness(100%);" />

              <img    :src="aboutClass === 'wider-about' 
            ? require('../../assets/logoNavbar2responsive.png') 
              : require('../../assets/qhatunavbar2.png')"  alt="Logo" width="50px" height="20px" class="logo px-auto"
                :class="{ 'logo-small  mt-4': aboutClass === 'wider-about' ,'ms-2': aboutClass != 'wider-about'  }">

              <img v-if="aboutClass == 'wider-about'" width="20" height="25" class="mt-4 mx-auto"  src="../../assets/logoSolimano.png" alt=""
                 />
            </div>
          </div>

                      <hr  v-if="aboutClass == 'wider-about'"   class="mx-2 pb-0 mb-0 border-top border-2 border-white">


          <nav class="px-0 ">
            <ul class="nav flex-column">
              <li class="nav-item w-100 text-center">
                <router-link to="/dashboard" class="text-decoration-none roboto15">
                  <div class="d-flex">
                    <svg xmlns="http://www.w3.org/2000/svg" class="text-white" width="20" height="20" fill="currentColor" :class="{
                      'bi bi-house  my-auto mx-auto': !ocultar,
                      'bi bi-house my-auto ms-2': ocultar,
                    }" viewBox="0 0 16 16">
                      <path fill-rule="evenodd"
                        d="M2 13.5V7h1v6.5a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5V7h1v6.5a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 13.5zm11-11V6l-2-2V2.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5z" />
                      <path fill-rule="evenodd"
                        d="M7.293 1.5a1 1 0 0 1 1.414 0l6.647 6.646a.5.5 0 0 1-.708.708L8 2.207 1.354 8.854a.5.5 0 1 1-.708-.708L7.293 1.5z" />
                    </svg>
                    <p v-if="ocultar" class=" my-auto tamaño colorTexto ms-2">
                      INICIO
                    </p>
                  </div>
                </router-link>
              </li>
            </ul>

            <!-- v-if="(item == 'OPERACIONES' && perfil == '8') || (item == 'SELECCION' && perfil == '2')  || (item == 'CONTRATOS' && perfil == '6')" -->
            <ul class="nav flex-column text-left roboto15">
              <li v-for="(item, index) in Items" :key="index.id" class="nav-item decorar">
                <div class="d-flex mt-2  w-100 justify-content-center">

                  <i :class="[
                    {
                      'my-auto colorTexto  fs-6 ': !ocultar,
                      'my-auto colorTexto fs-6 ms-2': ocultar
                    },
                    IconoModulo[index]
                  ]"></i>

                  <p v-if="ocultar" class="my-auto tamaño  ms-1 colorTexto1">
                    {{ item }}
                  </p>

                  <!-- FLECHA -->
                  <div @click="MostrarCategoria(index)"
                    :class="{ 'ms-auto px-2 py-1 ': ocultar, 'ms-1 py-1': !ocultar, }" class="" style="cursor: pointer;">
                    <i :class="[
                      'text-white fs-6',
                      moduloAbierto === index ? 'bi bi-chevron-up' : 'bi bi-chevron-down'
                    ]"></i>
                  </div>
                </div>

                <!-- <ul class="enlaces" v-for="(categoria, index) in ModuloRapido" :key="index.id">    
                  <p class="text-decoration-none tamaño py-0 my-2" :class="{
                    'categoria-seleccionada': categoriaSeleccionada === index,
                  }" @click="
                    seleccionarCategoria(
                      index,
                      categoria.idCategoria,
                      categoria.idModulo,
                      categoria.idGrupo,
                      categoria.idReporte
                    )
                    ">
                    <router-link v-if="
                      categoria.modNombre === item &&
                      categoria.catplataform == 2
                    " class="text-decoration-none tamaño" :to="categoria.idCategoria === 2
                      ? '/configuracion'
                      : categoria.idCategoria == 3
                        ? '/accesos'
                        : categoria.idCategoria == 1
                          ? '/usuarios'
                          : categoria.idCategoria == 85
                            ? '/reportes'
                            : '/cliente/' + categoria.idCategoria
                      ">
                      <div @click="getAttributes" class="d-flex">
                        <i :class="[
                          { 'mx-auto': !ocultar, 'ms-2': ocultar },
                          categoria.desIcono,
                          'fs-5',
                        ]"></i>
                        <p v-if="ocultar" class="my-auto tamaño w-100 ms-3">
                          {{ categoria.catNombre }}
                        </p>
                      </div>
                    </router-link>
                  </p>
                </ul> -->


                <ul class="enlaces roboto15" v-for="(categoria, index) in CategoriasDelModuloSeleccionado"
                  :key="index.id">
                  <p class="text-decoration-none tamaño py-0 my-2" :class="{
                    'categoria-seleccionada': categoriaSeleccionada === index,
                  }" @click="
                    seleccionarCategoria(
                      index,
                      categoria.idCategoria,
                      categoria.idModulo,
                      categoria.idGrupo,
                      categoria.idReporte
                    )
                    ">
                    <router-link v-if="
                      categoria.modNombre === item &&
                      categoria.catplataform == 2
                    " class="text-decoration-none " :to="categoria.idCategoria === 2
                      ? '/configuracion'
                      : categoria.idCategoria == 3
                        ? '/accesos'
                        : categoria.idCategoria == 1
                          ? '/usuarios'
                          : categoria.idCategoria == 85
                            ? '/reportes'
                            : '/cliente/' + categoria.idCategoria
                      ">
                      <div @click="getAttributes" class="d-flex">
                        <i :class="[
                          { 'mx-auto colorTexto': !ocultar, 'ms-2 colorTexto': ocultar },
                          categoria.desIcono,
                          'fs-5',
                        ]"></i>
                        <p v-if="ocultar" class="my-auto oscurecer colorTexto w-100 ms-1">
                          {{ categoria.catNombre }}
                        </p>
                      </div>
                    </router-link>
                  </p>
                </ul>


              </li>
            </ul>
          </nav>
          <div class="logout-container" :class="{'mx-1' : !ocultar , 'mx-3': ocultar }" @click="cerrarSesion">

            <div class="logout-icon d-flex justify-content-center text-center w-100" 
              style="cursor: pointer;">
              <i class="bi bi-power text-white fs-5 "></i>
            </div>

          </div>

          <!-- <footer>
            <p v-if="ocultar" style="font-size: 12px">
              Version 2.0.1 propierty of Grupo Solimano SAC...
            </p>
          </footer> -->
        </div>

        <!-- <button @click="muestra" class="btn btn-primary mt-3 mx-4 check">
      <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="currentColor" class="bi bi-list" viewBox="0 0 16 16">
  <path fill-rule="evenodd" d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"/>
</svg> -->
        <b-button class="check" v-b-modal.modal-xl><svg xmlns="http://www.w3.org/2000/svg" width="26" height="26"
            fill="currentColor" class="bi bi-list" viewBox="0 0 16 16">
            <path fill-rule="evenodd"
              d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z" />
          </svg>
        </b-button>

        <b-modal id="modal-xl" size="xl" class="bg-danger">
          <div class="agrandar">
            <ul class="nav flex-column">
              <li class="nav-item decorar">
                <router-link to="/" class="nav-link py-3 mx-2">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor"
                    class="bi bi-house mb-2" viewBox="0 0 16 16">
                    <path fill-rule="evenodd"
                      d="M2 13.5V7h1v6.5a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5V7h1v6.5a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 13.5zm11-11V6l-2-2V2.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5z" />
                    <path fill-rule="evenodd"
                      d="M7.293 1.5a1 1 0 0 1 1.414 0l6.647 6.646a.5.5 0 0 1-.708.708L8 2.207 1.354 8.854a.5.5 0 1 1-.708-.708L7.293 1.5z" />
                  </svg>
                  INICIO
                </router-link>
              </li>
            </ul>
          </div>
        </b-modal>

        <router-view> </router-view>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "BYNavbarVertical",

  data() {
    return {
      url: "/",
      perfil: "",
      aboutClass: "about",
      ocultar: true,
      categoriaSeleccionada: null,
      moduloAbierto: null,
      CategoriasDelModuloSeleccionado: []
    };
  },

  mounted() {
    this.perfil = localStorage.getItem("idPerfil");
  },

  computed: {
    ...mapGetters("users", [
      "Items",
      "ModuloRapido",
      "IconoModulo",
      "Idreporte",
      "Idgrupo",
    ]),
  },

  created() {
    this.getAttributes();
    this.ListarPerfil();
    this.ListarCatxPerfil();
    this.ListarCategorias();
    this.ListarModulo();
    this.ListarPerfilxUsuario();
    this.ListarUsuarios();
  },

  methods: {
    ...mapActions("users", ["getAttributes"]),
    ...mapActions("acciones", [
      "ListarPerfil",
      "ListarCatxPerfil",
      "ListarCategorias",
      "ListarModulo",
      "ListarPerfilxUsuario",
      "ListarUsuarios",
    ]),

    MostrarCategoria(index) {
      // Si el módulo ya está abierto → se cierra
      console.log(index)
      if (this.moduloAbierto === index) {
        console.log("CERRANDO módulo:", this.Items[index]);
        this.CategoriasDelModuloSeleccionado = []; // ← LIMPIA LAS CATEGORÍAS

        this.moduloAbierto = null;
        return;
      }

      this.categoriaSeleccionada = null


      console.log('items', this.ModuloRapido)
      // Si se está abriendo un módulo → se abre y muestra sus categorías
      console.log("ABRIENDO módulo:", this.Items[index]);

      const categoriasDelModulo = this.ModuloRapido.filter(
        c => c.modNombre === this.Items[index]
      );
      this.CategoriasDelModuloSeleccionado = categoriasDelModulo

      console.log("Categorías del módulo:", this.CategoriasDelModuloSeleccionado);

      this.moduloAbierto = index;
    },


    seleccionarCategoria(index, idCategoria, IdModulo, idGrupo, idReporte) {
      console.log("toy probando click");
      this.categoriaSeleccionada = index;
      this.$store.commit("users/llenarIdreporte", idReporte);
      this.$store.commit("users/llenarIdgrupo", idGrupo);

      this.$store.commit("users/activarTokenbi", true);

      const from = {
        idUsuario: localStorage.getItem("userId"),
        idModulo: IdModulo,
        idCategoria: idCategoria,
      };
      this.axios.post(`BIClientes/RegistrarMonitoreo`, from).then((r) => {
        console.log(r.data);
      });
      console.log(idCategoria, IdModulo, this.Idreporte, this.Idgrupo);
    },
    ocultarNavbar() {
      this.ocultar = !this.ocultar;
      this.aboutClass = !this.ocultar ? "wider-about" : "about";

      this.$store.dispatch("acciones/CambiosEstado", this.ocultar);
    },
    cerrarSesion() {
      localStorage.clear();

      window.location.reload(true);
      this.$router.push("/");
    },
  },
};
</script>

<style scoped>
.roboto15 {
  font-family: 'Roboto', sans-serif;
  font-size: 15px;
}

.categoria-seleccionada {
  background-color: #46a8f1;
  /* Otros estilos personalizados si es necesario */
}

.check {
  display: none;
}

.modales {
  background: #002c5d;
  margin-top: 8%;
  margin-bottom: auto;
  margin-left: auto;
  margin-right: auto;
  width: 40%;
  border-radius: 10px 10px 10px 10px;
  height: 40vh;
  color: white;
  
}

.wider-about {
  width: 3%;
  /* Ancho más amplio que el original */
  background: #0259b0;
  border-radius: 8px 8px 8px 8px;
  margin-left: 5px;
  /* padding-left: 5px; */
  margin-top: 9px;
  transition: 0.5s;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
  overflow-y: auto;
  overflow-x: hidden;
  height: auto;
  margin-bottom: 8px;

  /* margin-bottom: 1.05%; */
  /* opacity: 0.80;  */
   /* Esto vuelve TODO transparente, incluso tus textos */

}

.about {
  background: #0259b0;
  width: 18%;
  height: auto;
  border-radius: 10px 10px 10px 10px;
  margin-left: 5px;
  margin-top: 9px;
  transition: 0.5s;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
  overflow-y: auto;
  overflow-x: hidden;
  margin-bottom: 8px;

  /* opacity: 0.80;   */
  /* Esto vuelve TODO transparente, incluso tus textos */

  /* margin-bottom: 1.05%; */
}

/* .about:hover {
  transition: 0.5s;
  margin-left: 10px;
  margin-top: 9px;
} */

.aboute {
  background: #ffffff;
  width: 15%;
  height: 100vh;
  border-radius: 15px 15px 15px 15px;
  margin-left: 5px;
  margin-top: 9px;
  transition: 0.5s;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
  display: none;
}

.aboute:hover {
  transition: 0.5s;
  margin-left: 10px;
  margin-top: 20px;
}

.decorar {
  text-align: left;
  font-size: 0.8rem;
  padding-left: 0px;
  font-weight: 500;
  color: #454854;
  font-weight: 800;
}

.decorar:hover {
  transition: 0.5s;
}

.enlaces {
  margin-left: 0%;
  padding-left: 2%;
}

.tamaño {
  font-size: 0.85rem;
  color: #155bac;
  font-weight: 700;
}

.bg-solimano {
  background: #155bac;
}

.color {
  color: #155bac;
}

li a {
  text-align: left;
  padding-left: 0px;
  color: rgb(110, 112, 140);

}



.decoracion {
  list-style: none;
}

.logout-container {
  display: flex;
  align-items: center;
  padding: 10px;
  /* background-color: white; */
  /* Color de fondo */
  border-top: 1px solid #d5e0ec;
  /* Línea más gruesa */
}

.logout-icon i {
  font-size: 15px;
  /* Ajusta el tamaño del icono */
  margin-right: 5px;
  color: rgb(213, 4, 4);
  /* Color del icono, puedes ajustarlo */
}

.logout-text a {
  text-decoration: none;
  font-family: 'Roboto', sans-serif;
  color: rgb(213, 4, 4);
  font-size: 12px;
  font-weight: 400;
}

.logout-text a:hover {
  text-decoration: underline;
}

.logo {
  width: auto;
  /* tamaño normal */
  transition: 0.3s ease;
}

.logo-small {
  width: 32px;
  height: 22px;
  /* cuando el menú está en 3% */
}

.colorTexto {
  color: #F6F6F6;
  font-weight: 400;
  font-family: 'Inter', sans-serif;
  font-size: 9pt;
}
.colorTexto1 {
  color: #F6F6F6;
  font-weight: 500;
  font-size: 10pt;

}

.oscurecer:hover {
  font-weight: 720;
}
</style>